//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "NugentScoringCriteriaForGramStainingOfVaginalSecretions",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "4+" },
        { value: "1", name: "3+" },
        { value: "2", name: "2+" },
        { value: "3", name: "1+" },
        { value: "4", name: "0" },
      ],
      dataList1: [
      { value: "0", name: "0" },
      { value: "1", name: "1+" },
      { value: "2", name: "2+" },
      { value: "3", name: "3+" },
      { value: "4", name: "4+" },
      ],
      dataList2: [
        { value: "0", name: "0" },
        { value: "1", name: "1+或2+" },
        { value: "2", name: "3+或4+" },
      ],
      dataList3: [
      { value: "2", name: "≥1次躯干伸展后恢复到屈曲，手指摊开合拢" },
      { value: "0", name: "无活动，肢体完全伸展，伸展缓慢，部分恢复到屈曲" },
      ],
      dataList4: [
        { value: "2", name: "≥1个羊水暗区，最大羊水池垂直直径≥2cm" },
        { value: "0", name: "无或最大羊水池垂直直径＜2cm" },
      ],

    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/NugentScoringCriteriaForGramStainingOfVaginalSecretions.vue